/* eslint-disable @typescript-eslint/no-empty-function */
export const createObserverFromElement = ({
  callback,
  options,
  refElement,
}) => {
  var observer = new IntersectionObserver(callback, options);
  if (refElement) {
    return observer.observe(refElement);
  } else {
    return observer;
  }
};

export const createCallbackObserver = ({
  setIntersectorFunction,
  intersectorState,
  maxRatio,
  minRatio,
  setBooleanFunction,
  setRatioFunction,
  customCallback,
}) => {
  return function observerCallback(entries, observer) {
    customCallback(entries, observer);
    entries.forEach((entry) => {
      const currentRatio = entry.intersectionRatio;

      const isGoingUp = currentRatio <= intersectorState.lastRatio;

      setRatioFunction(entry.intersectionRatio);

      var reachMax;
      var crossMin;

      if (entry.intersectionRatio === maxRatio) {
        setBooleanFunction(false);
        reachMax = true;
        crossMin = false;
      } else if (entry.intersectionRatio <= minRatio) {
        setBooleanFunction(true);
        reachMax = false;
        crossMin = true;
      }

      setIntersectorFunction({
        isGoingUp,
        reachMax,
        crossMin,
        minRatio,
        maxRatio,
        lastRatio: currentRatio,
        lastEntry: entry,
        observer,
      });
    });
  };
};

const mainFunction = ({
  maxRatio = 0,
  minRatio = 1,
  setIntersectorFunction,
  intersectorState,
  customOptions = {},
  customThreshold = [],
  refElement,
  customCallback = () => {},
  setBooleanFunction = () => {},
  setRatioFunction = () => {},
}) => {
  let callback = createCallbackObserver({
    setIntersectorFunction,
    intersectorState,
    minRatio,
    maxRatio,
    customCallback,
    setBooleanFunction,
    setRatioFunction,
  });

  let options = {
    rootMargin: '0px',
    threshold: [minRatio, maxRatio, ...customThreshold],
    root: null,
    ...customOptions,
  };

  return createObserverFromElement({
    callback,
    options,
    refElement,
  });
};

export const setObserver = ({ observer, setObserver }) => {
  setObserver(observer);
};

export default mainFunction;
